export const PHONE_NUMBERS_FOR_UI = {
  TELNYX: "(917) 694-1965",
};
